import { useMemo } from 'react';
import { usePage } from '@inertiajs/react';
import { buildKestrel } from './fixtures/kestrel';

/**
 * The Kestrel dataset (fixtures/kestrel.js buildKestrel) for a vignette,
 * built once per mount in the page's `appTimezone`: the zone the app's
 * components read naive timestamps in, so the fixture's "just now" is the
 * components' "just now". The clock is fixed at mount; the stage builders it
 * returns all measure from that one instant.
 */
export default function useKestrel() {
    const timeZone = usePage().props?.appTimezone;

    return useMemo(() => buildKestrel({ timeZone: timeZone || undefined }), [timeZone]);
}
